import React from "react";
import { useGlobalContext } from "./context/globalContext";
import "../App.css";

const Details = ({ project }) => {
  const { handleShowModal } = useGlobalContext();

  const highlights1 = [
    "Blend of luxury, convenience and modern infrastructure",
    "Well-planned apartments with spacious layouts",
    "Top-notch amenities: swimming pool, gym, clubhouse",
  ];
  const highlights2 = [
    "Located in the thriving Mira Bhayandar area",
    "Designed for ample natural light and ventilation",
    "Modern interiors offering a comfortable lifestyle",
  ];

  return (
    <section className="section shadow-sm lazyloaded text-center" id="overview">
      <h1 className="d-block section-heading color-primary text-capitalize text-center">
        {project} - Overview
      </h1>

      <p className="overview-para">
        Welcome to Prestige Mira Road - a landmark residential development
        crafted by the Prestige Group, where contemporary elegance meets serene
        living. We bring to you a thoughtfully planned community featuring
        premium 1, 2 and 3 BHK residences designed for comfort, functionality,
        and style. Nestled in one of Mumbai's most well-connected suburbs, our
        project seamlessly blends lush green spaces with modern architecture.
        With world-class amenities, efficient layouts, and exceptional
        construction quality, Prestige Mira Road reflects our unwavering
        commitment to excellence. Here, you don't just buy a home — you invest
        in a lifestyle shaped by trust, innovation, and timeless design.
      </p>

      <center>
        <h3 className="mt-3" style={{ fontSize: "1.2rem" }}>
          {project} - Highlights
        </h3>
      </center>

      <div
        className="mr0 aos-init aos-animate mt-2"
        data-aos="fade-up"
        data-aos-delay="600"
        data-aos-duration="3000"
      >
        <div className="row">
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights1.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-6 col-md-6 col-sm-6">
            <ul className="whybuy text-capitalize">
              {highlights2.map((highlight, index) => (
                <li key={index}>
                  <span>{highlight}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <button
        className="chat-btn btn btn-info micro-form-btn effetGradient enqModal download_brochure"
        data-form="md"
        data-title="Download Brochure"
        data-btn="Download Now"
        data-enquiry="Download Brochure Welcome Text"
        data-redirect="brochure"
        data-redirect-file="brochure.pdf"
        data-toggle="modal"
        data-target="#enqModal"
        onClick={() => handleShowModal("Overview - Download Brochure")}
      >
        <span className="d-inline-block mi mi-download mr-1 animated slideInDown infinite"></span>{" "}
        Download Brochure
      </button>
    </section>
  );
};

export default Details;
